/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOlafReprocessJobStatusByReprocessKeyQueryResponse, GetOlafReprocessJobStatusByReprocessKeyPathParams, GetOlafReprocessJobStatusByReprocessKey404 } from "../models/GetOlafReprocessJobStatusByReprocessKey";

export function getGetOlafReprocessJobStatusByReprocessKeyUrl(reprocessKey: GetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"]) {
  const res = { method: 'GET', url: `/olaf/reprocess/job-status-by-reprocess-key/${reprocessKey}` as const }
  return res
}

/**
 * @description Finds and returns the most recent reprocess job for the given reprocess key within the user's client.
 * @summary Get OLAF reprocess job status by reprocess key
 * {@link /olaf/reprocess/job-status-by-reprocess-key/:reprocessKey}
 */
export async function getOlafReprocessJobStatusByReprocessKey(reprocessKey: GetOlafReprocessJobStatusByReprocessKeyPathParams["reprocessKey"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetOlafReprocessJobStatusByReprocessKeyQueryResponse, ResponseErrorConfig<GetOlafReprocessJobStatusByReprocessKey404>, unknown>({ method : "GET", url : getGetOlafReprocessJobStatusByReprocessKeyUrl(reprocessKey).url.toString(), ... requestConfig })
  return res.data
}